module.exports = __webpack_public_path__ + "img/emoji-smile.02baac9d.svg";